import React from 'react';

import { callPhoneNumber, helpPhoneNumber } from './util';
import phoneIcon from '../../images/mobile-phone-icon-blue.svg';
import styles from './AccountFinderHelp.css';

const AccountFinderHelp = () => (
    <div className="help-container">
        <img src={phoneIcon} alt="Phone Icon" />
        <div className="phone-number">
            Looking for help? Call{' '}
            <a id="helpNumber" href={`tel:${callPhoneNumber}`}>
                {helpPhoneNumber}
            </a>
        </div>
        <div className="help-subtext">
            Investment Specialists are available weekdays from 8 a.m. to 8 p.m.
            ET.
        </div>

        <style jsx>{styles}</style>
    </div>
);

export default AccountFinderHelp;
